// 礼物详情（EP-008-S6 / GDD 03 §②-2）。
// 大图 + 名称 + 档位 + desc + 首次获得时间 + 持有数量；未获得则不显示 desc / 时间 / 数量（B3）。
import { assetIndex, type AssetId } from '../assets/assetIndex';
import { GIFT_BY_ID } from '../domain/gifts/giftDef';
import { RARITY_NAME_BY_TIER, RARITY_TIER } from '../runtime/sequencer';
import { RarityDots } from './RarityDots';
import { Silhouette } from './Silhouette';
import type { InventoryStackV1 } from '../save/types';

interface ItemDetailProps {
  giftId: string;
  stack: InventoryStackV1 | undefined;
  onClose: () => void;
}

function formatDate(ts: number): string {
  // 仅「已获得回顾」信息（非 B1 审计子树），允许显示日期数字。
  const d = new Date(ts);
  const y = d.getFullYear();
  const m = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function ItemDetail({ giftId, stack, onClose }: ItemDetailProps) {
  const def = GIFT_BY_ID[giftId];
  const name = def?.name ?? giftId;
  const tier = def ? RARITY_TIER[def.rarity] : 1;
  const src = assetIndex[('gift_' + giftId) as AssetId];
  const obtained = !!stack;

  return (
    <div
      className="item-detail"
      role="dialog"
      aria-modal="true"
      aria-label={`${name} 详情`}
      tabIndex={-1}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="item-detail__panel">
        <button type="button" className="item-detail__close" onClick={onClose} aria-label="关闭详情">
          关闭
        </button>
        <div className="item-detail__media">
          {obtained ? (
            <img className="item-detail__img" src={src} alt="" aria-hidden="true" />
          ) : (
            <Silhouette giftId={giftId} />
          )}
        </div>
        <h2 className="item-detail__name">{name}</h2>
        <div className="item-detail__rarity">
          <RarityDots tier={tier} />
          <span className="item-detail__rarity-name">{RARITY_NAME_BY_TIER[tier]}</span>
        </div>
        {obtained ? (
          <>
            <p className="item-detail__desc">{def?.desc}</p>
            <p className="item-detail__meta">首次获得 {formatDate(stack!.firstObtainedAt)}</p>
            <p className="item-detail__meta">持有 ×{stack!.count}</p>
          </>
        ) : (
          <p className="item-detail__desc item-detail__desc--locked">还没获得，等它回来带给你。</p>
        )}
      </div>
    </div>
  );
}
